var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// - Import react components
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import moment from 'moment/moment';
import Input from '@material-ui/core/Input';
import { grey } from '@material-ui/core/colors';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import SvgCamera from '@material-ui/icons/PhotoCamera';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import EventListener from 'react-event-listener';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import { withStyles } from '@material-ui/core/styles';
import Stripe from 'components/stripe';
import { StripeProvider, Elements } from 'react-stripe-elements';
// - Import app components
import ImgCover from 'components/imgCover';
import UserAvatarComponent from 'components/userAvatar';
import ImageGallery from 'components/imageGallery';
import AppDialogTitle from 'layouts/dialogTitle';
import SizeButtons from 'components/sizeButtons';
// - Import actions
import * as userActions from 'store/actions/userActions';
var styles = function (theme) {
    var _a, _b, _c, _d;
    return ({
        dialogTitle: {
            padding: 0
        },
        dialogContentRoot: (_a = {
                maxHeight: 400,
                minWidth: 330
            },
            _a[theme.breakpoints.down('xs')] = {
                maxHeight: '100%',
            },
            _a),
        fullPageXs: (_b = {},
            _b[theme.breakpoints.down('xs')] = {
                width: '100%',
                height: '100%',
                margin: 0
            },
            _b),
        fixedDownStickyXS: (_c = {},
            _c[theme.breakpoints.down('xs')] = {
                position: 'fixed',
                bottom: 0,
                right: 0,
                background: 'white',
                width: '100%'
            },
            _c),
        bottomPaperSpace: (_d = {
                height: 16
            },
            _d[theme.breakpoints.down('xs')] = {
                height: 90
            },
            _d),
        box: {
            padding: '0px 24px 0px',
            display: 'flex'
        },
        boxcard: {
            padding: '0px 0px 0px',
            display: 'flex'
        },
        bottomTextSpace: {
            marginBottom: 15
        },
        dayPicker: {
            width: '100%',
            padding: '13px 0px 8px'
        }
    });
};
/**
 * Create component class
 */
var FirstLoginComponent = /** @class */ (function (_super) {
    __extends(FirstLoginComponent, _super);
    /**
     * Component constructor
     * @param  {object} props is an object properties of component
     */
    function FirstLoginComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.styles = {
            avatar: {
                border: '2px solid rgb(255, 255, 255)'
            },
            paper: {
                width: '100%',
                height: '100%',
                margin: '0 auto',
                display: 'block',
                fontFamily: 'Lato',
            },
            title: {
                padding: '24px 24px 20px 24px',
                font: '500 20px Roboto,RobotoDraft,Helvetica,Arial,sans-serif',
                display: 'flex',
                wordWrap: 'break-word',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                flexGrow: 1
            },
            actions: {
                display: 'flex',
                justifyContent: 'flex-end',
                padding: '24px 24px 20px'
            },
            updateButton: {
                marginLeft: '10px'
            },
            dialogGallery: {
                width: '',
                maxWidth: '530px',
                borderRadius: '4px'
            },
            iconButtonSmall: {},
            iconButton: {}
        };
        _this.small = React.createRef();
        _this.medium = React.createRef();
        _this.large = React.createRef();
        _this.xl = React.createRef();
        /**
         * Close image gallery of banner
         */
        _this.handleCloseBannerGallery = function () {
            _this.setState({
                openBanner: false
            });
        };
        /**
         * Open image gallery of banner
         */
        _this.handleOpenBannerGallery = function () {
            _this.setState({
                openBanner: true
            });
        };
        /**
         * Close image gallery of avatar
         */
        _this.handleCloseAvatarGallery = function () {
            _this.setState({
                openAvatar: false
            });
        };
        /**
         * Open image gallery of avatar
         */
        _this.handleOpenAvatarGallery = function () {
            _this.setState({
                openAvatar: true
            });
        };
        /**
         * Set banner image url
         */
        _this.handleRequestSetBanner = function (url) {
            _this.setState({
                banner: url
            });
        };
        /**
         * Set avatar image url
         */
        _this.handleRequestSetAvatar = function (fileName) {
            _this.setState({
                avatar: fileName
            });
        };
        /**
         * Update profile on the server
         *
         *
         * @memberof EditProfile
         */
        _this.handleUpdate = function () {
            var _a = _this.state, fullNameInput = _a.fullNameInput, tagLineInput = _a.tagLineInput, avatar = _a.avatar, banner = _a.banner, selectedBirthday = _a.selectedBirthday, companyName = _a.companyName, webUrl = _a.webUrl, twitterId = _a.twitterId, DefaultSize = _a.DefaultSize, firstTime = _a.firstTime, ShippingAddress = _a.ShippingAddress, city = _a.city, zip = _a.zip, userName = _a.userName;
            var _b = _this.props, info = _b.info, update = _b.update;
            _this.setState({
                firstTime: false
            });
            if (fullNameInput.trim() === '') {
                _this.setState({
                    fullNameInputError: 'This field is required'
                });
            }
            else {
                _this.setState({
                    fullNameInputError: ''
                });
                update({
                    fullName: fullNameInput,
                    tagLine: tagLineInput,
                    avatar: avatar,
                    banner: banner,
                    firstTime: firstTime || false,
                    companyName: companyName,
                    webUrl: webUrl,
                    userName: userName,
                    DefaultSize: DefaultSize,
                    ShippingAddress: ShippingAddress || '',
                    city: city || '',
                    zip: zip || '',
                    twitterId: twitterId,
                    creationDate: _this.props.info.creationDate,
                    birthday: selectedBirthday > 0 ? selectedBirthday : ((info && info.birthday) ? info.birthday : 0),
                });
            }
        };
        /**
         * Handle data on input change
         * @param  {event} evt is an event of inputs of element on change
         */
        _this.handleInputChange = function (event) {
            var _a;
            var target = event.target;
            var value = target.type === 'checkbox' ? target.checked : target.value;
            var name = target.name;
            _this.setState((_a = {},
                _a[name] = value,
                _a));
        };
        /**
         * Handle resize event for window to change sidebar status
         * @param  {any} event is the event is passed by winodw resize event
         */
        _this.handleResize = function (event) {
            // Set initial state
            var width = window.innerWidth;
            if (width > 900) {
                _this.setState({
                    isSmall: false
                });
            }
            else {
                _this.setState({
                    isSmall: true
                });
            }
        };
        /**
         * Handle birthday date changed
         */
        _this.handleBirthdayDateChange = function (date) {
            _this.setState({ selectedBirthday: moment(date).unix() });
        };
        _this.capitalize = function (str) {
            //  const {post} = this.props
            //  post.get('ownerDisplayName')
            if (str) {
                //  var string = post.get('ownerDisplayName')
                str = str.toLowerCase()
                    .split(' ')
                    .map(function (s) { return s.charAt(0).toUpperCase() + s.substring(1); })
                    .join(' ');
            }
            return str;
        };
        // Defaul state
        _this.state = {
            /**
             * If it's true the winow is in small size
             */
            isSmall: false,
            /**
             * User tag line input value
             */
            tagLineInput: props.info.tagLine || '',
            /**
             * User full name input value
             */
            fullNameInput: props.info.fullName || '',
            /**
             * Error message of full name input
             */
            fullNameInputError: '',
            /**
             * User banner address
             */
            banner: props.banner || 'https://media.giphy.com/media/f4pMuyoZwE5QQ/giphy.gif',
            /**
             * User avatar address
             */
            avatar: props.avatar || '',
            /**
             * It's true if the image galley for banner is open
             */
            openBanner: false,
            /**
             * It's true if the image gallery for avatar is open
             */
            openAvatar: false,
            /**
             * Default birth day
             */
            defaultBirthday: (props.info && props.info.birthday) ? moment.unix(props.info.birthday).toDate() : '',
            /**
             * Seleted birth day
             */
            selectedBirthday: 0,
            /**
             * Web URL
             */
            webUrl: (props.info && props.info.webUrl) ? props.info.webUrl : '',
            /**
             * User company name
             */
            companyName: (props.info && props.info.companyName) ? props.info.companyName : '',
            /**
             * User twitter id
             */
            twitterId: (props.info && props.info.twitterId) ? props.info.twitterId : '',
            // Location: (props.info && props.info.Location) ? props.info.Location : ''
            DefaultSize: (props.info && props.info.DefaultSize) ? props.info.DefaultSize : '',
            firstTime: props.firstTime,
            ShippingAddress: (props.info && props.info.ShippingAddress) ? props.info.ShippingAddress : '',
            city: (props.info && props.info.city) ? props.info.city : '',
            zip: (props.info && props.info.zip) ? props.info.zip : '',
            userName: (props.info && props.info.userName) ? props.info.userName : '',
        };
        // Binding functions to `this`
        _this.handleUpdate = _this.handleUpdate.bind(_this);
        _this.handleRequestSetAvatar = _this.handleRequestSetAvatar.bind(_this);
        _this.handleRequestSetBanner = _this.handleRequestSetBanner.bind(_this);
        return _this;
    }
    FirstLoginComponent.prototype.componentDidMount = function () {
        this.handleResize(null);
    };
    /**
     * Reneder component DOM
     * @return {react element} return the DOM which rendered by component
     */
    FirstLoginComponent.prototype.render = function () {
        var _this = this;
        if (this.state.DefaultSize === 'Small') {
            var small = this.small.current;
            if (small) {
                small.style.backgroundColor = 'black';
            }
        }
        else {
            var small = this.small.current;
            if (small) {
                small.style.backgroundColor = 'transparent';
            }
        }
        if (this.state.DefaultSize === 'Medium') {
            var Medium = this.medium.current;
            if (Medium) {
                Medium.style.backgroundColor = 'black';
            }
        }
        else {
            var Medium = this.medium.current;
            if (Medium) {
                Medium.style.backgroundColor = 'transparent';
            }
        }
        if (this.state.DefaultSize === 'Large') {
            var large = this.large.current;
            if (large) {
                large.style.backgroundColor = 'black';
            }
        }
        else {
            var large = this.large.current;
            if (large) {
                large.style.backgroundColor = 'transparent';
            }
        }
        if (this.state.DefaultSize === 'Xl') {
            var xl = this.xl.current;
            if (xl) {
                xl.style.backgroundColor = 'black';
            }
        }
        else {
            var xl = this.xl.current;
            if (xl) {
                xl.style.backgroundColor = 'transparent';
            }
        }
        var _a = this.props, classes = _a.classes, translate = _a.translate, currentLanguage = _a.currentLanguage;
        var _b = this.state, defaultBirthday = _b.defaultBirthday, webUrl = _b.webUrl, twitterId = _b.twitterId, companyName = _b.companyName, ShippingAddress = _b.ShippingAddress, city = _b.city, zip = _b.zip, userName = _b.userName;
        var iconButtonElement = (React.createElement(IconButton, { style: this.state.isSmall ? this.styles.iconButtonSmall : this.styles.iconButton },
            React.createElement(MoreVertIcon, { style: __assign({}, (this.state.isSmall ? this.styles.iconButtonSmall : this.styles.iconButton), { color: grey[400] }), viewBox: '10 0 24 24' })));
        var RightIconMenu = function () { return (React.createElement("div", null,
            iconButtonElement,
            React.createElement(MenuItem, { style: { fontSize: '14px' } }, "Reply"),
            React.createElement(MenuItem, { style: { fontSize: '14px' } }, "Edit"),
            React.createElement(MenuItem, { style: { fontSize: '14px' } }, "Delete"))); };
        var firstName = this.props.fullName.split(' ').slice(0, -1).join(' ');
        return (React.createElement("div", { style: { maxWidth: '100',
                overflowX: 'hidden' } },
            React.createElement(Dialog, { PaperProps: { className: classes.fullPageXs }, key: 'Edit-Profile', open: this.props.open, onClose: this.props.onRequestClose, maxWidth: 'sm' },
                React.createElement(DialogContent, { className: classes.dialogContentRoot },
                    React.createElement("div", { style: { position: 'relative' } },
                        React.createElement(ImgCover, { width: '100%', height: '250px', borderRadius: '2px', fileName: this.state.banner }),
                        React.createElement("div", { className: 'g__circle-black', onClick: this.handleOpenBannerGallery, style: { position: 'absolute', right: '10px', top: '10px' } },
                            React.createElement(SvgCamera, { style: { fill: 'rgba(255, 255, 255, 0.88)', transform: 'translate(6px, 6px)' } }))),
                    React.createElement("div", { className: 'profile__edit' },
                        React.createElement(EventListener, { target: 'window', onResize: this.handleResize }),
                        React.createElement("div", { className: 'left' },
                            React.createElement("div", { style: { display: 'flex', justifyContent: 'center' } },
                                React.createElement("div", { className: 'g__circle-black', onClick: this.handleOpenAvatarGallery, style: { zIndex: 1, position: 'absolute', left: '50%', display: 'inline-block', top: '52px', margin: '-18px' } },
                                    React.createElement(SvgCamera, { style: { fill: 'rgba(255, 255, 255, 0.88)', transform: 'translate(6px, 6px)' } })),
                                React.createElement(UserAvatarComponent, { fullName: (this.props.info ? this.capitalize(this.props.info.fullName) : ''), fileName: this.state.avatar, size: 90, style: this.styles.avatar })),
                            React.createElement("div", { className: 'info' },
                                React.createElement("div", { style: { fontFamily: 'Lato',
                                        fontSize: '18px', fontWeight: 400, width: '100%', margin: 'auto', marginBottom: '3%', textAlign: 'center' } },
                                    "Welcome To HullThread, ",
                                    this.capitalize(firstName),
                                    "!",
                                    React.createElement("br", null),
                                    "Lets get started.")))),
                    React.createElement(Paper, { style: this.styles.paper, elevation: 1 },
                        React.createElement("div", { style: { fontFamily: 'Lato',
                                padding: '12px', marginTop: '2%', marginBottom: '2%', fontSize: '16px', fontWeight: 400 } }, translate('profile.personalInformationLabel')),
                        React.createElement("div", { className: classes.box },
                            React.createElement(FormControl, { fullWidth: true, "aria-describedby": 'fullNameInputError' },
                                React.createElement(InputLabel, { htmlFor: 'fullNameInput' }, translate('profile.fullName')),
                                React.createElement(Input, { id: 'fullNameInput', onChange: this.handleInputChange, name: 'fullNameInput', value: this.state.fullNameInput }),
                                React.createElement(FormHelperText, { id: 'fullNameInputError' }, this.state.fullNameInputError))),
                        React.createElement("div", { className: classes.box },
                            React.createElement(TextField, { className: classes.bottomTextSpace, onChange: this.handleInputChange, name: 'userName', value: userName, label: 'Username', fullWidth: true })),
                        React.createElement("div", { className: classes.box },
                            React.createElement(TextField, { className: classes.bottomTextSpace, onChange: this.handleInputChange, name: 'companyName', value: companyName, label: translate('profile.companyName'), fullWidth: true })),
                        React.createElement("div", { className: classes.box },
                            React.createElement(TextField, { className: classes.bottomTextSpace, onChange: this.handleInputChange, name: 'ShippingAddress', value: ShippingAddress, label: translate('profile.ShippingAddress'), fullWidth: true })),
                        React.createElement("div", { className: classes.box },
                            React.createElement(TextField, { className: classes.bottomTextSpace, onChange: this.handleInputChange, name: 'city', value: city, label: translate('profile.city'), fullWidth: true })),
                        React.createElement("div", { className: classes.box },
                            React.createElement(TextField, { className: classes.bottomTextSpace, onChange: this.handleInputChange, name: 'zip', value: zip, label: translate('profile.zip'), fullWidth: true })),
                        React.createElement("br", null),
                        React.createElement("div", { style: { padding: '12px', fontFamily: 'Lato' } }, "Default Size: "),
                        React.createElement("div", { className: classes.box, style: { width: '70%', textAlign: 'center', margin: 'auto', display: 'flex', justifyContent: 'space-between' } },
                            React.createElement("div", { ref: this.small, onClick: function () { return _this.setState({ DefaultSize: 'Small' }); }, style: { borderRadius: '50%', float: 'left' } },
                                React.createElement(SizeButtons, { Csize: 'S' })),
                            React.createElement("div", { ref: this.medium, onClick: function () { return _this.setState({ DefaultSize: 'Medium' }); }, style: { borderRadius: '50%', float: 'left' } },
                                React.createElement(SizeButtons, { Csize: 'M' })),
                            React.createElement("div", { ref: this.large, onClick: function () { return _this.setState({ DefaultSize: 'Large' }); }, style: { borderRadius: '50%', float: 'left' } },
                                React.createElement(SizeButtons, { Csize: 'L' })),
                            React.createElement("div", { ref: this.xl, onClick: function () { return _this.setState({ DefaultSize: 'Xl' }); }, style: { borderRadius: '50%', float: 'left' } },
                                React.createElement(SizeButtons, { Csize: 'XL' }))),
                        React.createElement("br", null),
                        React.createElement("div", { style: { margin: 'auto' } },
                            React.createElement(StripeProvider, { apiKey: 'pk_live_D07HlPhslhVq2EdCmzd6oypm' },
                                React.createElement(Elements, null,
                                    React.createElement(Stripe, { uid: this.props.uid })))),
                        React.createElement("br", null)),
                    React.createElement("div", { className: classes.bottomPaperSpace })),
                React.createElement(DialogActions, { className: classes.fixedDownStickyXS },
                    React.createElement(Button, { onClick: this.props.onRequestClose },
                        " ",
                        translate('profile.cancelButton'),
                        " "),
                    React.createElement(Button
                    // variant='raised' 
                    , { 
                        // variant='raised' 
                        color: 'primary', onClick: this.handleUpdate, style: this.styles.updateButton },
                        " ",
                        translate('profile.updateButton'),
                        " "))),
            React.createElement(Dialog, { PaperProps: { className: classes.fullPageXs }, open: this.state.openBanner, onClose: this.handleCloseBannerGallery },
                React.createElement(DialogTitle, { className: classes.dialogTitle },
                    React.createElement(AppDialogTitle, { title: translate('profile.chooseBanerDialogTitle'), onRequestClose: this.handleCloseBannerGallery })),
                React.createElement(ImageGallery, { set: this.handleRequestSetBanner, close: this.handleCloseBannerGallery })),
            React.createElement(Dialog, { PaperProps: { className: classes.fullPageXs }, open: this.state.openAvatar, onClose: this.handleCloseAvatarGallery },
                React.createElement(DialogTitle, { className: classes.dialogTitle },
                    React.createElement(AppDialogTitle, { title: translate('profile.chooseAvatarDialogTitle'), onRequestClose: this.handleCloseAvatarGallery })),
                React.createElement(ImageGallery, { set: this.handleRequestSetAvatar, close: this.handleCloseAvatarGallery }))));
    };
    FirstLoginComponent.propTypes = {
        /**
         * User avatar address
         */
        avatar: PropTypes.string,
        /**
         * User avatar address
         */
        banner: PropTypes.string,
        /**
         * User full name
         */
        fullName: PropTypes.string.isRequired
    };
    return FirstLoginComponent;
}(Component));
export { FirstLoginComponent };
/**
 * Map dispatch to props
 * @param  {func} dispatch is the function to dispatch action to reducers
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapDispatchToProps = function (dispatch, ownProps) {
    return {
        update: function (info) { return dispatch(userActions.dbUpdateUserInfo(info)); },
        onRequestClose: function () { return dispatch(userActions.closeEditProfile()); }
    };
};
/**
 * Map state to props
 * @param  {object} state is the obeject from redux store
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapStateToProps = function (state, ownProps) {
    var uid = state.getIn(['authorize', 'uid']);
    return {
        currentLanguage: getActiveLanguage(state.get('locale')).code,
        translate: getTranslate(state.get('locale')),
        open: state.getIn(['user', 'openEditProfile'], false),
        info: state.getIn(['user', 'info', uid]),
        avatarURL: state.getIn(['imageGallery', 'imageURLList']),
        uid: uid
    };
};
// - Connect component to redux store
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(FirstLoginComponent));



//////////////////
// WEBPACK FOOTER
// ./src/components/FirstLogin/FirstLoginComponent.tsx
// module id = 1565
// module chunks = 0 1 2 3